export default __webpack_public_path__ + "static/media/complementary--dead-end--g1.1e58d714.png";